module.exports = __webpack_public_path__ + "static/prairiedevcon19-main-9d88f970f2dd1723566c845168bd9e0e.jpeg";